export enum TagType {
TagType1,
TagType2,
}
